import React from "react"
import { Link } from "gatsby"

import MainLayout from "../../components/layout"
import SEO from "../../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"

import Intro from "../../components/SubPages/IntroSubPages/introSubPages";
import CardGrid from "../../components/SubPages/AwsTerraformPage/CardGrid/cardGrid";
import PrincingCards from "../../components/SubPages/AwsTerraformPage/PricingCards/pricingCards";

import Img from "../../images/products/meet.png"
import AwsIcon from "../../images/solutions/serverless/AWS Lambda.png"
import ArchitechIcon from "../../images/solutions/serverless/architecture.png"
import CertifiedIcon from "../../images/solutions/serverless/Certified engineers.png"

import mockImg from "../../images/realtime/Serverless.svg"


import Constants from "../../constants/solutions.json"

const GridData = [
  {
    title: Constants.SOLUTIONS.servelessSolutions.GridDataArray.i1.title,
    description:
      Constants.SOLUTIONS.servelessSolutions.GridDataArray.i1.description,
    img: AwsIcon,
  },
  {
    title: Constants.SOLUTIONS.servelessSolutions.GridDataArray.i2.title,
    description:
      Constants.SOLUTIONS.servelessSolutions.GridDataArray.i2.description,
    img: ArchitechIcon,
  },
  {
    title: Constants.SOLUTIONS.servelessSolutions.GridDataArray.i3.title,
    description:
      Constants.SOLUTIONS.servelessSolutions.GridDataArray.i3.description,
    img: CertifiedIcon,
  },
]

const ServerlessSolutions = () => (
  <MainLayout>
    <SEO
      title="AWS Terraform and multi-platform Kubernetes Jitsi Infrastructure as Code"
      description="Building a Jitsi video conferencing platform just got easier!!! We bring to you tailor-made terraform scripts for installation of Jitsi meet, JVBs and Jibri on AWS (Amazon web services), GCP (Google Cloud Platform), Microsoft Azure cloud infrastructure"
      pagePath="/solutions/aws-terraform-and-multi-platform-kubernetes-jitsi-infrastructure-as-code"
      schema={`{
              "@context": "https://meetrix.io/solutions/aws-terraform-and-multi-platform-kubernetes-jitsi-infrastructure-as-code",
              "@type": "WebPage",
              "mainEntity": {
                "@type": "Organization",
                "name": "Meetrix.io",
              }
            }`}
    />
    <Intro
      title="AWS Terraform and multi-platform Kubernetes Jitsi Infrastructure as Code"
      description="Building a video conferencing platform never got any better! We bring to you tailor-made terraform scripts for installation of Jitsi meet in AWS (Amazon web services), GCP (Google Cloud Platform), Microsoft Azure cloud infrastructure"
      // blueTitle={Constants.SOLUTIONS.servelessSolutions.MainLayout.blueTitle}
      yellowTitle="Learn More"
      yellowLink="https://meetrix.io/blog/aws/jitsi-meet-terraform-scripts-for-jvb-and-jibri-autoscaling.html"
      // blueLink=""
      background={mockImg}
      
    />
    <CardGrid />
    <PrincingCards />
  </MainLayout>
)

export default ServerlessSolutions
